import React, { useState } from "react";
import { toast } from "react-toastify";
import ErrorMessage from "../../../components/comman/ErrorMessage";

const MultipleGTC = ({
  title = "Documents Checklist for Billing",
  setGtc,
  gtcList = [],
  name,
  required = true,
  placeholder = "Add Documents Checklist for Billing",
  ...rest
}) => {
  const [text, setText] = useState("");
  const [error, setError] = useState("");

  const validateInput = (value) => {
    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setError("Please enter a valid email address.");
        return false;
      }
    } else if (name === "phone") {
      const phoneRegex = /^[6-9]\d{9}$/;
      if (!phoneRegex.test(value)) {
        setError("Please enter a valid 10-digit phone number.");
        return false;
      }
    }
    return true;
  };

  const addTodo = () => {
    const newText = text.trim();
    if (!newText) return;

    if (!validateInput(newText)) return;

    if (gtcList.includes(newText)) {
      toast.warning("This item already exists in the list.");
      return;
    }

    setGtc((prev) => ({
      ...prev,
      [name]: [...(prev?.[name] || []), newText],
    }));

    setText("");
    setError("");
  };

  const deleteTodo = (index) => {
    setGtc((prev) => ({
      ...prev,
      [name]: prev?.[name]?.filter((_, i) => i !== index),
    }));
  };

  return (
    <>
      <div className="form-group mb-3">
        <label className="form-label">
          {title} {required && <span className="text-danger">*</span>}
        </label>
        <div className="d-flex gap-2">
          <input
            type={
              name === "email" ? "email" : name === "phone" ? "number" : "text"
            }
            className="form-control"
            placeholder={placeholder}
            value={text}
            onChange={(e) => setText(e.target.value)}
            {...rest}
          />
          <button
            className="btn btn-primary"
            type="button"
            onClick={addTodo}
            disabled={!text.trim()}
          >
            Add
          </button>
        </div>
        <ErrorMessage message={error} />
      </div>

      {gtcList.length > 0 && (
        <ul className="list-group">
          {gtcList.map((todo, index) => (
            <li
              key={index}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <span className="flex-grow-1">{todo}</span>
              <button
                className="btn btn-sm btn-outline-danger ms-3"
                onClick={() => deleteTodo(index)}
              >
                ✖
              </button>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default MultipleGTC;
